// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-page-with-title .form-contents[data-v-036aab8c]{max-width:600px}.auth-page-with-title .border[data-v-036aab8c]{border-width:3px;display:flex}.auth-page-with-title .border .another[data-v-036aab8c]{padding:30px 15px}", ""]);
// Exports
module.exports = exports;
